import { NavLink, Outlet } from 'react-router-dom';
import { currentPolicyVersions } from '@emazy/shared-types';

import { Container } from '@/components/common';
import { routes } from '@/config/routes';
import { useCustomerProfile, useInitializeConsents } from '@/features/account/hooks';

const items = [
  [routes.accountProfile, 'pi-user', 'Profile'],
  [routes.accountCommunication, 'pi-envelope', 'Communication'],
  [routes.accountSecurity, 'pi-shield', 'Security'],
  [routes.accountConsents, 'pi-history', 'Consent history'],
] as const;

export function AccountLayout() {
  const profile = useCustomerProfile();
  const initialize = useInitializeConsents();
  return (
    <Container>
      <div className="account-layout">
        <aside className="account-sidebar" aria-label="Account navigation">
          <p className="account-sidebar__eyebrow">Your Emazy account</p>
          <h1>Account settings</h1>
          <nav>
            {items.map(([to, icon, label]) => (
              <NavLink key={to} to={to}>
                <i className={`pi ${icon}`} aria-hidden="true" />
                {label}
              </NavLink>
            ))}
          </nav>
          <NavLink className="account-sidebar__dashboard" to={routes.dashboard}>
            Back to dashboard
          </NavLink>
        </aside>
        <section className="account-content">
          {profile.data?.consentSetupRequired && (
            <div className="account-notice" role="status">
              <div>
                <strong>Confirm your current account agreements</strong>
                <p>
                  We need to record your acknowledgement of the current Terms and Privacy Policy.
                </p>
              </div>
              <button
                className="button-link button-link--primary"
                type="button"
                disabled={initialize.isPending}
                onClick={() =>
                  initialize.mutate({
                    termsPolicyVersion: currentPolicyVersions.terms,
                    privacyPolicyVersion: currentPolicyVersions.privacy,
                  })
                }
              >
                {initialize.isPending ? 'Confirming…' : 'Acknowledge'}
              </button>
            </div>
          )}
          <Outlet />
        </section>
      </div>
    </Container>
  );
}
